import { useAtomValue, useSetAtom } from 'jotai';
import { showContactSellerModalAtom } from '../../atoms';

export const useShowContactSellerModal = () => useAtomValue(showContactSellerModalAtom);

export const useShowContactSellerModalUpdater = () => useSetAtom(showContactSellerModalAtom);
